/**
 * Map levels for geographic maps
 * Defined in GeographicMapLevel.kt
 */

export default {
	EARTH3D: 'earth3d',
	EARTH2D: 'earth2d',
	CONTINENT: 'continent',
	COUNTRY: 'country',
	STATE_PROVINCE: 'state-province',
	COUNTY: 'county',
	POSTAL_CODE: 'postal-code',
	CITY: 'city'
}